import * as React from "react";

const CalendarIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
            <path
                fill="#75B8C8"
                d="M3.5,0 C3.7750001,0 4,0.223875046 4,0.5 L4,2 L10,2 L10,0.5 C10,0.223875046 10.2250004,0 10.5,0 C10.7749996,0 11,0.223875046 11,0.5 L11,2 L12,2 C13.1031246,2 14,2.89531231 14,4 L14,14 C14,15.1031246 13.1031246,16 12,16 L2,16 C0.895312309,16 0,15.1031246 0,14 L0,4 C0,2.89531231 0.895312309,2 2,2 L3,2 L3,0.5 C3,0.223875046 3.2249999,0 3.5,0 Z M13,6 L1,6 L1,14 C1,14.5531254 1.44781256,15 2,15 L12,15 C12.5531254,15 13,14.5531254 13,14 L13,6 Z M12,3 L2,3 C1.44781256,3 1,3.44687462 1,4 L1,5 L13,5 L13,4 C13,3.44687462 12.5531254,3 12,3 Z"
            />
        </svg>
    );
};

export default React.memo(CalendarIcon);
